import { axiosInstance } from '../api';

export default function(studyId) {
    return axiosInstance.post(`/api/studyreview/approve/${studyId}`);
}